@if (!registration) {
<div class="not-supported-widget">
  <mat-icon>help_outline</mat-icon>
  <p>Type de widget non supporté: {{ widget.type }}</p>
</div>
}
